import { ApiContactNatureType } from '../api-types/contact-nature-type.api';
import { ContactNatureType } from '../app-types/contact-nature-type';

/**
 * Transforms an ApiContactNatureType object to an app-specific ContactNatureType object.
 * @description This function maps properties of the ApiContactNatureType to the ContactNatureType interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiContactNatureType
 * @returns ContactNatureType
 */
export const transformApiContactNatureTypeToAppContactNatureType = (input: ApiContactNatureType) => {
	const output: ContactNatureType = {
		id: input.id,
		remark: input.remark,
		initial: input.initial,
	};
	return output;
};

/**
 * Transforms an array of ApiContactNatureType objects to an array of app-specific
 * ContactNatureType objects.
 * @param input Array of ApiContactNatureType objects
 * @description Transforms an array of ApiContactNatureType objects to an array of app-specific ContactNatureType objects.
 * @returns Array of app-specific ContactNatureType objects
 */
export const transformApiContactNatureTypesToAppContactNatureTypes = (input: ApiContactNatureType[]) => {
	const output: ContactNatureType[] = input.map(transformApiContactNatureTypeToAppContactNatureType);
	return output;
};

/**
 * Transforms an app-specific ContactNatureType object to an ApiContactNatureType object.
 * @description This function maps properties of the ContactNatureType to the ApiContactNatureType interface.
 * It is used to convert data from the application into a format that can be sent to the API.
 * @param input ContactNatureType
 * @returns ApiContactNatureType
 */
export const transformAppContactNatureTypeToApiContactNatureType = (input: ContactNatureType) => {
	const output: ApiContactNatureType = {
		id: input.id,
		remark: input.remark,
		initial: input.initial,
	};
	return output;
};
